<template>
    <section id="services" class="services blue-grey lighten-5">
        <div class="row container">
            <div class="col s12">
                <!-- <div class="title center">Services</div> -->
                <div class="title center"><img src="/assets/images/services.png"></div>
            </div>
            <div class="col s12 m12 l4">
                <!-- <div class="card-panel sunday white">
                    <div class="left">
                        <i class="ln ln-icon-Daylight"></i>
                        <span class="card-title">Sunday</span>
                        <span class="card-title-sub">Worship Service</span>
                        <span class="white-tefxt">
                            <br>Join us as we worship our Heavenly Father and learn Biblical principles that we can apply to our everyday lives<br><br>
                            Sunday School: 9:45 AM &ndash; 10:30 AM<br>
                            <em>Sunday School Classes: Children, Youth and Young Adult</em><br><br>
                            Worship Service: 10:45 AM<br><br>
                            Food and fellowship immediately follows the conclussion of the service. 
                        </span>
                    </div>
                    <div style="clear: both"></div>
                </div> -->

                <div class="card-panel white wednesday">
                    <div class="left">
                        <i class="ln ln-icon-Daylight"></i>
                        <span class="card-title">Sunday</span>
                        <span class="card-title-sub">Worship Service</span>
                        <span class="white-tfext">
                            <br>Join us as we worship our Heavenly Father and learn Biblical principles that we can apply to our everyday lives<br><br>
                            10:45 AM
                        </span>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
            <div class="col s12 m12 l4">
                <div class="card-panel white friday">
                    <div class="left">
                        <i class="ln ln-icon-Daylight"></i>
                        <span class="card-title">Sunday</span>
                        <span class="card-title-sub">Servizio Italiano</span>
                        <span class="white-tefxt">
                            <br>Unisciti a noi mentre adoriamo e apprendiamo i principi biblici che possiamo applicare alla nostra vita quotidiana<br><br>
                            2 PM &ndash; 3 PM
                        </span>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
            <div class="col s12 m12 l4">
                <!-- <div class="card-panel white wednesday">
                    <div class="left">
                        <i class="ln ln-icon-Half-Moon"></i>
                        <span class="card-title">Wednesday</span>
                        <span class="card-title-sub">Bible Study</span>
                        <span class="white-tfext">
                            <br>Delving deeper into the Word of God<br><br>
                            7 PM &ndash; 8 PM
                        </span>
                    </div>
                    <div style="clear: both"></div>
                </div> -->
                <div class="card-panel white friday">
                    <div class="left">
                        <i class="ln ln-icon-Daylight"></i>
                        <span class="card-title">Saturday</span>
                        <span class="card-title-sub">Prayer Meeting</span>
                        <span class="white-tefxt">
                            <br>Utilizing our most powerful tool: Prayer!<br><br><br>
                            11 AM &ndash; 12 PM<br>&nbsp;
                        </span>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
            <div class="col s12 center button-div">
                <a class="waves-effect waves-light btn-large" href="#location">Join Us</a>
            </div>  
        </div>
    </section>
</template>

<script>
export default {
    name: "Services"
};
</script>

<style scoped>
    section {
        padding: 4.5rem 0rem 3.5rem 0rem;
    }

    .title { 
        margin-bottom: 1rem;
    }

    .card-panel {
        position: relative;
    }
    
    .card-panel.sunday {
        min-height: 415px;
    }

    .card-panel.wednesday,
    .card-panel.friday {
        min-height: 200px;
    }

    .card-panel:hover {
        -webkit-box-shadow: 0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2);
        box-shadow: 0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2);
    }
    
    .card-panel i {
        position: absolute;
        top: 15px; 
        right: 15px;
    }

    .card-panel.wednesday i,
    .card-panel.friday i {
        font-size: 3.25rem;
    }

    .card-title {
        display: block;
        text-transform: uppercase;
    }
    
    .card-title-sub {
        display: block;
        font-size: 1.75rem;
        font-family: NewhouseDTCond-ExtBold;
    }

    p {
        font-size: 1.5rem;
        line-height: 1.25;
    }

    i {
        font-size: 4rem;
    }

    .button-div {
        margin-top: 2rem;
    }

    .button-div a {
        line-height: 58px;
        font-size: 1.4rem;
        padding: 0px 50px;
        background: rgba(91,124,138, 1);
    }

    .button-div a:hover {
        background: rgba(91,124,138, .7);
        color: #fff;
    }
    @media screen and (max-width: 993px) {
        .card-panel.sunday {
            min-height: initial;
        }
    }
</style>